export function formatDateMDY(dateString: string): string {
    const date = new Date(dateString);
    const month = date.toLocaleString("default", { month: "long" });
    const formattedDate = `${month} ${date.getDate()}, ${date.getFullYear()}`;

    return formattedDate;
}

export function formatDateMY(dateString: string): string {
    const date = new Date(dateString);
    const month = date.toLocaleString("default", { month: "long" });
    const formattedDate = `${month} ${date.getFullYear()}`;
    return formattedDate; // e.g. January, 2025
}

export function getDateText(publishedAt: string | null, updatedAt: string): string {
    if (!publishedAt) {
        return `Updated on ${formatDateMDY(updatedAt)}`;
    }

    const publishedDate = new Date(publishedAt).toLocaleDateString("en-EN");
    const updatedDate = new Date(updatedAt).toLocaleDateString("en-EN");

    if (publishedDate < updatedDate) {
        return `Updated on ${formatDateMDY(updatedAt)}`;
    }

    return `Published on ${formatDateMDY(publishedAt)}`;
}
